<template>
  <div class="clientNav">
    <nav class="navbar-vertical fixed-left navbar-expand-xs">
      <ul>
        <li v-if="isClient">
          <!-- <a href="#"><i class="fa fa-home"></i> -->
          <router-link to="/client/dashboard" class="nav-link">
            <span class="hint"   title="Offers">                     

            <i class="fa fa-desktop" aria-hidden="true"></i></span>
          </router-link>
        </li>
         <li v-if="isAdmin || isRep">
          <!-- <a href="#"><i class="fa fa-home"></i> -->
          <router-link to="/client/admin-dashboard" class="nav-link">
            <span class="hint"   title="Offers">                     

            <i class="fa fa-desktop" aria-hidden="true"></i></span>
          </router-link>
        </li>
       
        <li>
          <router-link to="/client/mybids" class="nav-link">
            <span class="hint"   title="Bids/Buys">                     
            <i class="fa fa-list" aria-hidden="true"></i></span>
          </router-link>
        </li>
         <li>
          <!-- <a href="#"><i class="fa fa-filter"></i> -->
          <router-link to="/client/filter" class="nav-link">
            <span class="hint"   title="Filters">                     
            <i class="fa fa-filter" aria-hidden="true"></i> </span>
          </router-link>
        </li>
        <li v-if="isRep || isAdmin">
          <router-link to="/client/notifications" class="nav-link">
            <span class="hint"   title="Notifications">                     
            <i class="fa fa-bell" aria-hidden="true"></i></span>
          </router-link>
        </li>
         <li v-if="isAdmin || isRep">
          <router-link to="/client/list" class="nav-link">
            <span class="hint"   title="Users">                     
            <i class="fa fa-users" aria-hidden="true"></i></span>
          </router-link>
        </li>
      
        <li >
          <router-link to="/client/portfolio" class="nav-link">
            <span class="hint"   title="Portfolio">                     
            <i class="fa fa-briefcase" aria-hidden="true"></i></span>
          </router-link>
        </li>
         <li v-if="isAdmin">
          <router-link to="/client/settings" class="nav-link">
            <span class="hint"   title="Settings">  
            <i class="fa fa-cog" aria-hidden="true"></i>  </span>
          </router-link>
        </li>

         <li v-if="isAdmin || isRep">
          <router-link to="/client/client-activity" class="nav-link">
            <span class="hint"   title="Activity Stats">  
            <i class="fa fa-chart-line" aria-hidden="true"></i>  </span>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isClient: false,
      isAdmin: false,
      isRep: false,
    }
  },
   created() {
      this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Client')   ? this.isClient  = true : this.isClient  = false;
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Rep')   ? this.isRep  = true : this.isRep = false;
        }
      });

  },
}
</script>
<style scoped>
  .nav-link.router-link-exact-active {
  color: #fff;
  
}
</style>